import React from 'react'
import styles from './styles.module.css'

function ClinicalData() {
  return (
    <div className={styles.clinical_data}>
      <p>患者编号</p>
      <p>出生日期</p>
      <p>性别</p>
      <p>实验室检查结果及时间</p>
      <p>诊断文本和/或ICD-10编码及时间</p>
    </div>
  )
}

export default ClinicalData
